module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-601.f32a601.woff2";